<template>
    <transition>
    <div class="container-fluid card-body">
        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <div class="page-title-right float-left">
                        <ol class="breadcrumb m-0"> 
                            <li class="breadcrumb-item active">Reports </li>
                            <li class="breadcrumb-item"><a href="javascript: void(0);">Audit Logs</a></li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 ">
                <div class="card">
                    <div class="card-header border-bottom bg-white">
                        <h4 class="card-title mb-0">System Audit Logs</h4>
                    </div>
                    <div class="card-body">
                        <table class="table table-bordered table-centered table-nowarp w-100" v-if="!loading">
                            <thead class="table-light">
                                <tr class="border success item-head">
                                    <th class="text-center" width="5%">SL </th>
                                    <th class="text-center" width="15%">Date/Time</th>
                                    <th class="text-center" width="15%">Module / Action</th>
                                    <th class="text-center" width="20%">Reference No</th>
                                    <th class="text-center" width="25%">Updated By</th>
                                </tr>
                            </thead>
                            <tbody v-if="items.length > 0">
                                <tr class="border" v-for="(item, index) in items" :key="index">
                                    <td class="text-center">{{ index + 1 }} </td>
                                    <td class="text-center">{{ item.created_at }} </td> 
                                    <td class="text-center"><span class="badge bg-info">{{ item.update_reason || 'Purchase Order Update' }}</span> <span class="badge bg-secondary ms-1">v{{ item.version }}</span></td> 
                                    <td class="text-center">{{ item.purchase_order ? item.purchase_order.reference_no : 'N/A' }} </td> 
                                    <td class="text-center">{{ item.updater ? item.updater.name : 'System' }} </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td colspan="5" class="text-center text-muted">No audit logs found.</td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="tab-pane show active" v-if="loading">
                            <div class="row"> 
                                <div class="col-md-5"></div>
                                <div class=" col-md-2"> 
                                    <div class="spinner"></div>
                                </div>
                                <div class="col-md-5"></div>
                            </div>
                        </div>

                    </div> 
                </div>
            </div>
        </div>
    </div>
    </transition>
</template>

<script> 
import axios from 'axios';  
export default {
    name: 'AuditLogs',
    data() {
        return {
            loading: true,
            items: [],
        };
    },
    created() {
        this.fetchAuditLogsData();
    },
    methods: { 
        fetchAuditLogsData() { 
            axios.get(this.apiUrl+'/audit_logs', this.headerjson)
            .then((res) => {
                this.items = res.data.data;
            }).finally(( ) => {
                this.loading = false;
            });
        },
    },
    mounted() {
        window.scrollTo(0, 0);
    }
}
</script>

<style scoped>
.spinner {
    width: 75px;
    height: 75px;
    display: inline-block;
    border-width: 2px;
    border-color: rgba(0, 0, 0, 0.05);
    border-top-color: #000;
    animation: spin 1s infinite linear;
    border-radius: 100%;
    border-style: solid;
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
